<!-- @component
Here's some documentation for this component.
It will show up on hover.

- You can use markdown here.
- You can also use code blocks here.
-->

<!------------------------------- HTML ------------------------------------->

<dialog id=appearanceDialog data-help="deployment" bind:this={dialog} onclose={closing_dialog}
        onclick={(e) => { if (e.target === dialog) dialog.close() }}>
	<h3>Eingesetzter NSC</h3>
	<img class="close button" src="/static/buttons/close.png" alt="close" onclick={() => dialog.close()}>
	<div class=container>
		<img class="affil-{editeds.affil} rank{editeds.rank}" src={deploy.tokenURL} title={deploy.ID} alt={deploy.name}>
		<div class=datagrid>
			<Input field=callsign bind:value={editeds.callsign} disabled separate />
			<p></p>
			<Select field=rank bind:value={editeds.rank} options={rankOptions} defaultval={deploy.rank} separate />
			<Input field=level value={editeds.level} defaultval={deploy.level} type=number disabled separate />
			<p></p>
			<Select field=affil bind:value={editeds.affil} options={affilOptions} defaultval={deploy.affil} separate />
			<Input field=condition bind:value={editeds.condition} defaultval="Hidden oder Invisible" separate class=quadspan />
			<div class=buttonBar>
				<button class="btn-primary btn-primary-circle icon-check" onclick={change_deployment} title="OK">
					Ändern
				</button>
				<button class="btn-primary btn-primary-circle icon-trash" onclick={delete_deployment}>
					Löschen
				</button>
			</div>
		</div>
	</div>
</dialog>


<!------------------------------- SCRIPT ------------------------------------->

<script>
	import { user, game, view, send_data } from "../client.svelte.js";
	import {notEmpty, calc_defaultCS, token_URL, isEmpty} from "../core.js";
	import Input from "../elements/Input.svelte";
	import Select from "../elements/Select.svelte";
	import {onDestroy, onMount} from "svelte";

		let dialog      // this HTML element
		let { deploy } = $props()

	let editeds = $state((({callsign, rank, affil, condition}) => ({callsign, rank, affil, condition}))($state.snapshot(deploy)))
	const attributes = ['callsign', 'rank', 'affil', 'condition']
	const rankOptions = [{ID: 1, name: "Anfänger"}, {ID: 2, name: "Standard"}, {ID: 3, name: "Veteran"}, {ID: null, name: "Individuum"}]
	const affilOptions = [{ID: 'enemy', name: "Feind"}, {ID: 'friend', name: "Freund"}, {ID: 'neutral', name: "Neutral"}]

	// $inspect(`DEPLOY: editeds = `, editeds)

	onMount( () => { dialog.showModal() })
	function closing_dialog() {  view.close_dialog() }

	function change_deployment() {
		const changes = Object.fromEntries(Object.entries(editeds).filter(([attr,val]) => val !== deploy[attr]))
		if (notEmpty(changes)) {
			const requestData = Object.assign({ID: deploy.deployID, ADVT: view.adventure.ID, SECT: view.section.SECT, CS: deploy.callsign}, changes)
			console.log(`DEPLOY: edit deployment ${deploy.deployID} `, $state.snapshot(requestData))
			send_data(`/deploy/${deploy.deployID}`, requestData, 'PATCH')
		}
		dialog.close()
	}

	function delete_deployment() {
		console.log(`DEPLOY-DIALOG: delete deployment ${deploy.deployID}.`)
		send_data(`/deploy/${deploy.deployID}`, {}, 'DELETE')
		dialog.close()
	}
</script>


<style lang="sass">
	@use "../colors" as colors

	dialog
		position: absolute
		margin: 0
		top: 50%
		left: 50%
		transform: translateY(-50%) translateX(-50%)
		min-height: 222px
		background-color: #444444
		overflow: hidden

	.close
		position: absolute
		float: right
		width: 16px
		right: 16px
		top: 16px
		padding: 0
		color: grey

	.container
		display: flex

	.container img
		width: 200px
		padding: 8px
		object-fit: contain
		border-radius: 100%

	.datagrid
		display: grid
		grid-template-columns: 6ch 6ch 2ch 6ch 14ch
		align-content: start
		width: 340px
		column-gap: 4px
		margin: 4px
		padding: 8px
		background-color: #111111

	.buttonBar
		width: 336px
		margin: 32px 4px 4px 4px
		display: flex
		gap: 36px
		justify-content: center

	h3
		color: colors.$white
		grid-column: span 2
		justify-self: center

	input[type=checkbox]
		color: lightgrey
		accent-color: dimgrey

	input[type="checkbox"]:not(:checked)
		appearance: none
		margin: 4px 34px
		width: 20px
		height: 20px
		background: dimgrey

	.miniButton
		width: 138px
		height: auto

	.miniButton img
		width: 48px

	.miniButton span
			position: relative
			top: -16px

</style>